var MyCollectionProtocol = {
	reqExportInventory:
		function(itemType)
		{
			return new Promise(
				function( resolve, reject )
				{
					if ( !blapp.session.isLoggedIn() )
					{
						reject("NOT_LOGGEDIN");
						blapp.refs.get( "header" ).toggleMenu( "login" );
					}
					else {
						blapp.models.fetch(
							"_pi"
							, {
									controller: "user.BLCUserMyPersonalInventory"
								, 	method: "exportInventory"
								, 	params: [ itemType ]
								, 	refresh: true
							}
						).then(
							(data) => {
								resolve(data);
							}
						).catch(
							(err) => {
								reject(err);
							}
						);
					}
				}

			)
		}

,	reqUpdateListingOptions:
		function(itemType, listingOptions)
		{
			return new Promise(
				function( resolve, reject )
				{
					if ( !blapp.session.isLoggedIn() )
					{
						reject("NOT_LOGGED_IN");
						blapp.refs.get( "header" ).toggleMenu( "login" );
					}
					else {
						blapp.models.fetch(
							"_pi"
							, {
									controller: "user.BLCUserMyPersonalInventory"
								, 	method: "updateMyInventorySettings"
								, 	params: [ itemType, listingOptions.strListViewType, listingOptions.nListSize, listingOptions.nListSortType, listingOptions.nListOrder ]
								, 	refresh: true
							}
						).then(
							(data) => {
								resolve(data);
							}
						).catch(
							(err) => {
								reject(err);
							}
						);
					}
				}

			)

		}
,	reqGetListItem:
		function( itemType, reqPage, listingOptions, keyword, listCategoryFilter )
		{
			return new Promise(
				function ( resolve, reject )
				{
					if ( !blapp.session.isLoggedIn() )
					{
						reject("NOT_LOGGEDIN");
						blapp.refs.get( "header" ).toggleMenu( "login" );
					}
					else {
						blapp.models.fetch(
							"_pi"
							, {
									controller: "user.BLCUserMyPersonalInventory"
								, 	method: "getItemList"
								, 	params: [itemType, reqPage, listingOptions.nListSize, listingOptions.nListSortType, listingOptions.nListOrder, keyword, listCategoryFilter]
								, 	refresh: true
							}
						).then(
							(data) => {
								resolve(data);
							}
						).catch(
							(err) => {
								reject(err)
							}
						);
					}

				}
			)
		}
,   reqListCategory:
        function( strKeyword )
		{
			return new Promise(
				function ( resolve, reject )
				{
					if ( !blapp.session.isLoggedIn() )
					{
						reject("NOT_LOGGEDIN");
						blapp.refs.get( "header" ).toggleMenu( "login" );
					}
					else {
                        blapp.models.fetch(
							"_pi"
							, {
									controller: "user.BLCUserMyPersonalInventory"
								, 	method: "getCategoryList"
								, 	params: [strKeyword]
								, 	refresh: true
							}
						).then(
							(data) => {
								if (data != null) {
                                    const retData = {
                                        A: [],
                                        S: data.sList,
                                        P: data.pList,
                                        M: data.mList,
                                        B: data.bList,
                                        G: data.gList,
                                        C: data.cList,
                                    }
									resolve(retData);
								}
							}
						).catch(
							(err) => {
								reject(err)
							}
						);
					}
				}
			
			)
		}
,   reqItemInvInfo: 
        function( idItem ) 
        {
            const param = [idItem];

            return new Promise(
                function ( resolve, reject )
				{
                    
                    //resolve({nRegInvCnt: 0, nExtraInvCnt: 0, nMinifigureCnt: 0});
                    
					blapp.models.fetch(
						"_pi"
						, {
								controller: "user.BLCUserMyPersonalInventory"
							, 	method: "getItemInvCnt"
							, 	params: param
							, 	refresh: true
						}
					).then(
						(data) => {
                            resolve(data);
						}
					).catch(
						(err) => {
							reject(err)
						}
					);
                    
				}
			
            )
        }
,	reqGenInvInfo:
		function( keyword, listCategory )
		{
            const param = [keyword, listCategory];
            
			var getListOption = (listOptions, itemType)=>this.getListOption(listOptions, itemType);
			return new Promise(
				function ( resolve, reject )
				{
					if ( !blapp.session.isLoggedIn() )
					{
						reject("NOT_LOGGEDIN");
						blapp.refs.get( "header" ).toggleMenu( "login" );
					}
					else {

						blapp.models.fetch(
							"_pi"
							, {
									controller: "user.BLCUserMyPersonalInventory"
								, 	method: "getCommonData"
								, 	params: [keyword, listCategory]
								, 	refresh: true
							}
						).then(
							(data) => {
                                
								if (data != null) {
									let listingOptions = {
                                            A: getListOption(data.listOptions, "A")
										,	S: getListOption(data.listOptions, "S")
										,	P: getListOption(data.listOptions, "P")
										,	M: getListOption(data.listOptions, "M")
										,	B: getListOption(data.listOptions, "B")
										,	G: getListOption(data.listOptions, "G")
										,	C: getListOption(data.listOptions, "C")
									}
									data.listingOptions = listingOptions;
									resolve(data);
								}
							}
						).catch(
							(err) => {
								reject(err)
							}
						);
					}
				}
			
			)
		}
,	reqAddItems:
		function(arrAddedItem)
		{
			return new Promise(
				function ( resolve, reject )
				{
					if ( !blapp.session.isLoggedIn() )
					{
						reject("NOT_LOGGEDIN");
						blapp.refs.get( "header" ).toggleMenu( "login" );
					}
					else {
						blapp.models.fetch(
							"_pi"
							, {
									controller: "user.BLCUserMyPersonalInventory"
								, 	method: "addItems"
								, 	params: [ arrAddedItem ]
								, 	refresh: true
							}
						).then(
							(data) => {
								resolve(data);
							}
						).catch(
							(err) => {
								reject(err);
							}
						);
					}
				}
			)
		}

,	reqUpdateInvQty: 
		function (listItemUpdate) 
		{
			return new Promise(
				function ( resolve, reject )
				{
					if ( !blapp.session.isLoggedIn() )
					{
						reject("NOT_LOGGEDIN");
						blapp.refs.get( "header" ).toggleMenu( "login" );
					}
					else {
						blapp.models.fetch(
							"_pi"
							, {
									controller: "user.BLCUserMyPersonalInventory"
								, 	method: "updateInventory"
								, 	params: [ listItemUpdate ]
								, 	refresh: true
							}
						).then(
							(data) => {
								resolve( data );
							}
						).catch(
							(err) => {
								reject( err );
							}
						);
					}
				}
			)
		}

,	getListOption:
		function( listOptions, itemType )
		{
			for(const listOption of listOptions) {
				if (listOption.strItemType == itemType) return listOption;
			}
			return null;
		}

,	reqListPartColor:
		function(idItem, itemType) 
		{
			return new Promise(
				function ( resolve, reject )
				{

					blapp.models.fetch(
						"_overview_guide"
					,	{
							controller:		"catalog.BLCCatalogColorGuide"
						,	method:			"getItemColorGuideWithItemType"
						,	params:			[ idItem, itemType ]
						,	refresh:		true
						}
					).then(
						( data ) =>
						{
							if ( data && data.length > 0 )
							{
								let	mapTypes	= {};
								let	arrTypes	= [];

								_.forEach( 
									data
								,	( c ) =>
									{
										const	ci	= blapp.color.get( c.idColor );
										c.ci = ci;
									}
								)

								data.sort( 
									( l, r ) =>
									{
										let	cl	= blapp.color.get( l.idColor );
										let	cr	= blapp.color.get( r.idColor );
										let	tl	= cl ? cl.typeColor : 999;
										let tr	= cr ? cr.typeColor : 999;

										if ( tl == tr )
										{
											let	nl	= cl ? cl.strColorName : "(Unknown)";
											let	nr	= cr ? cr.strColorName : "(Unknown)";

											return nl.localeCompare( nr );
										}

										return tl - tr; 
									}
								);
							}
							resolve( { colorList: data } );
						}
					).catch(
						( err ) =>
						{
							refuse( err );
						}
					)
				}
			);
		}
,	getSearchQuickWithItemType:
		function( query, itemType )
		{
			return new Promise(
				function ( resolve, reject )
				{
					if ( !blapp.session.isLoggedIn() )
					{
						reject("NOT_LOGGEDIN");
						blapp.refs.get( "header" ).toggleMenu( "login" );
					}
					else {
						blapp.models.fetch(
							"_pi"
							, {
									controller: "user.BLCUserMyPersonalInventory"
								, 	method: "searchItemWithItemType"
								, 	params: [ query, itemType ]
								, 	refresh: true
							}
						).then(
							(data) => {
								resolve(data);
							}
						).catch(
							(err) => {
								reject(err);
							}
						);
					}
				}
			)
		}
};

export default MyCollectionProtocol;

function	getListCategory() {
	const category = {
		A: [
            {idCategory: 1, catName: "Animal, Accessory", itemCnt: 52} ,
            {idCategory: 2, catName: "Animal, Air", itemCnt: 120} ,
            {idCategory: 3, catName: "Animal, Body Part", itemCnt: 166} ,
            {idCategory: 4, catName: "Animal, Body Part, Decorated", itemCnt: 525} ,
            {idCategory: 5, catName: "Animal, Dinosaur", itemCnt: 86} ,
            {idCategory: 6, catName: "Animal, Land", itemCnt: 587} ,
            {idCategory: 7, catName: "Animal, Water", itemCnt: 90} ,
            {idCategory: 8, catName: "Antenna", itemCnt: 15} ,
            {idCategory: 9, catName: "Arch", itemCnt: 36} ,
            {idCategory: 10, catName: "Arch, Decorated", itemCnt: 69} ,
            {idCategory: 11, catName: "Arm", itemCnt: 20} ,
            {idCategory: 12, catName: "Ball", itemCnt: 22} ,
            {idCategory: 13, catName: "Bar", itemCnt: 56} ,
            {idCategory: 14, catName: "BasePlate", itemCnt: 85},
            {idCategory: 15, catName: "Animal, Accessory", itemCnt: 52} ,
            {idCategory: 16, catName: "Animal, Air", itemCnt: 120} ,
            {idCategory: 17, catName: "Animal, Body Part", itemCnt: 166} ,
            {idCategory: 18, catName: "Animal, Body Part, Decorated", itemCnt: 525} ,
            {idCategory: 19, catName: "Animal, Dinosaur", itemCnt: 86} ,
            {idCategory: 20, catName: "Animal, Land", itemCnt: 587} ,
            {idCategory: 21, catName: "Animal, Water", itemCnt: 90} ,
            {idCategory: 22, catName: "Antenna", itemCnt: 15} ,
            {idCategory: 23, catName: "Arch", itemCnt: 36} ,
            {idCategory: 24, catName: "Arch, Decorated", itemCnt: 69} ,
            {idCategory: 25, catName: "Arm", itemCnt: 20} ,
            {idCategory: 26, catName: "Ball", itemCnt: 22} ,
            {idCategory: 27, catName: "Bar", itemCnt: 56} ,
            {idCategory: 28, catName: "Animal, Accessory", itemCnt: 52} ,
            {idCategory: 29, catName: "Animal, Air", itemCnt: 120} ,
            {idCategory: 30, catName: "Animal, Body Part", itemCnt: 166} ,
            {idCategory: 31, catName: "Animal, Body Part, Decorated", itemCnt: 525} 
        ],
        S: [
            {idCategory: 32, catName: "Animal, Dinosaur", itemCnt: 86} ,
            {idCategory: 33, catName: "Animal, Land", itemCnt: 587} ,
            {idCategory: 34, catName: "Animal, Water", itemCnt: 90} ,
            {idCategory: 35, catName: "Antenna", itemCnt: 15} ,
            {idCategory: 36, catName: "Arch", itemCnt: 36} ,
            {idCategory: 37, catName: "Arch, Decorated", itemCnt: 69} ,
            {idCategory: 38, catName: "Arm", itemCnt: 20} ,
            {idCategory: 39, catName: "Ball", itemCnt: 22} ,
            {idCategory: 40, catName: "Bar", itemCnt: 56} ,
            {idCategory: 41, catName: "Animal, Accessory", itemCnt: 52} ,
            {idCategory: 42, catName: "Animal, Air", itemCnt: 120} ,
            {idCategory: 43, catName: "Animal, Body Part", itemCnt: 166} ,
            {idCategory: 44, catName: "Animal, Body Part, Decorated", itemCnt: 525} ,
            {idCategory: 45, catName: "Animal, Dinosaur", itemCnt: 86} ,
            {idCategory: 46, catName: "Animal, Land", itemCnt: 587} ,
            {idCategory: 47, catName: "Animal, Water", itemCnt: 90} ,
            {idCategory: 48, catName: "Antenna", itemCnt: 15} ,
            {idCategory: 49, catName: "Arch", itemCnt: 36} ,
            {idCategory: 50, catName: "Arch, Decorated", itemCnt: 69} ,
            {idCategory: 51, catName: "Arm", itemCnt: 20} ,
            {idCategory: 52, catName: "Ball", itemCnt: 22} ,
            {idCategory: 53, catName: "Bar", itemCnt: 56} ,
            {idCategory: 54, catName: "Animal, Accessory", itemCnt: 52} ,
            {idCategory: 55, catName: "Animal, Air", itemCnt: 120} ,
            {idCategory: 56, catName: "Animal, Body Part", itemCnt: 166} ,
            {idCategory: 57, catName: "Animal, Body Part, Decorated", itemCnt: 525} 
        ],
		P: [
            {idCategory: 58, catName: "Animal, Dinosaur", itemCnt: 86} ,
            {idCategory: 59, catName: "Animal, Land", itemCnt: 587} ,
            {idCategory: 60, catName: "Animal, Water", itemCnt: 90} ,
            {idCategory: 61, catName: "Antenna", itemCnt: 15} ,
            {idCategory: 62, catName: "Arch", itemCnt: 36} ,
            {idCategory: 63, catName: "Arch, Decorated", itemCnt: 69} ,
            {idCategory: 64, catName: "Arm", itemCnt: 20} ,
            {idCategory: 65, catName: "Ball", itemCnt: 22} ,
            {idCategory: 66, catName: "Bar", itemCnt: 56} ,
            {idCategory: 67, catName: "Animal, Accessory", itemCnt: 52} ,
            {idCategory: 68, catName: "Animal, Air", itemCnt: 120} ,
            {idCategory: 69, catName: "Animal, Body Part", itemCnt: 166}
        ],
        B: [
            {idCategory: 70, catName: "Animal, Body Part, Decorated", itemCnt: 525} ,
            {idCategory: 71, catName: "Animal, Dinosaur", itemCnt: 86} ,
            {idCategory: 72, catName: "Animal, Land", itemCnt: 587} ,
            {idCategory: 73, catName: "Animal, Water", itemCnt: 90} ,
            {idCategory: 74, catName: "Antenna", itemCnt: 15} ,
            {idCategory: 75, catName: "Arch", itemCnt: 36} ,
            {idCategory: 76, catName: "Arch, Decorated", itemCnt: 69} ,
            {idCategory: 77, catName: "Arm", itemCnt: 20} ,
            {idCategory: 78, catName: "Ball", itemCnt: 22} ,
            {idCategory: 79, catName: "Bar", itemCnt: 56} ,
            {idCategory: 80, catName: "Animal, Accessory", itemCnt: 52}
        ],
        M: [
            {idCategory: 81, catName: "Animal, Air", itemCnt: 120} ,
            {idCategory: 82, catName: "Animal, Body Part", itemCnt: 166} ,
            {idCategory: 83, catName: "Animal, Body Part, Decorated", itemCnt: 525} ,
            {idCategory: 84, catName: "Animal, Dinosaur", itemCnt: 86} ,
            {idCategory: 85, catName: "Animal, Land", itemCnt: 587} ,
            {idCategory: 86, catName: "Animal, Water", itemCnt: 90} ,
            {idCategory: 87, catName: "Antenna", itemCnt: 15}
        ],
        C: [
            {idCategory: 88, catName: "Arch", itemCnt: 36} ,
            {idCategory: 89, catName: "Arch, Decorated", itemCnt: 69} ,
            {idCategory: 90, catName: "Arm", itemCnt: 20} ,
            {idCategory: 91, catName: "Ball", itemCnt: 22} ,
            {idCategory: 92, catName: "Bar", itemCnt: 56} ,
            {idCategory: 93, catName: "Animal, Accessory", itemCnt: 52} ,
            {idCategory: 94, catName: "Animal, Air", itemCnt: 120}
        ],
        G: [
            {idCategory: 95, catName: "Animal, Body Part", itemCnt: 166} ,
            {idCategory: 96, catName: "Animal, Body Part, Decorated", itemCnt: 525} ,
            {idCategory: 97, catName: "Animal, Dinosaur", itemCnt: 86} ,
            {idCategory: 98, catName: "Animal, Land", itemCnt: 587} ,
            {idCategory: 99, catName: "Animal, Water", itemCnt: 90} 
        ]
	};
	return category;
}


function getItemListTest() {
	const testData = {
		listItems: getTestItemListData()
	,	listCategory: getTestListCategory()	
	}
	return testData;
}

function getTestListCategory() {
	const testCategory = [
		{ idCategory: 0, catName: "Brik", itemCnt: 100}
	];

}

function getTestItemListData() {
	const itemList = 
	[
        {
            "invId": 6676,
            "itemNo": "44728",
            "itemSeq": 0,
            "itemName": "Bracket 1 x 2 - 2 x 2",
            "invNew": "N",
            "invComplete": "S",
            "itemType": "P",
            "invItemID": 17759,
            "categoryId": 0,
            "catString": "4",
            "catNames": [
                "Bracket"
            ],
            "catIds": [
                4
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/PN/5/44728.png",
            "invQty": 1,
            "invColorID": 5,
            "invYN": "N",
            "invCondition": 1,
            "pccList": [
                "4277933",
                "6048856",
                "6117974",
                "4185525"
            ],
            "markedAsDeletion": false
        },
        {
            "invId": 6656,
            "itemNo": "3010",
            "itemSeq": 0,
            "itemName": "Brick 1 x 4",
            "invNew": "N",
            "invComplete": "S",
            "itemType": "P",
            "invItemID": 326,
            "categoryId": 0,
            "catString": "5",
            "catNames": [
                "Brick"
            ],
            "catIds": [
                5
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/PN/7/3010.png",
            "invQty": 1,
            "invColorID": 7,
            "invYN": "N",
            "invCondition": 1,
            "pccList": [
                "301023"
            ],
            "markedAsDeletion": false
        },
        {
            "invId": 6655,
            "itemNo": "3003",
            "itemSeq": 0,
            "itemName": "Brick 2 x 2",
            "invNew": "N",
            "invComplete": "S",
            "itemType": "P",
            "invItemID": 272,
            "categoryId": 0,
            "catString": "5",
            "catNames": [
                "Brick"
            ],
            "catIds": [
                5
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/PN/4/3003.png",
            "invQty": 2,
            "invColorID": 4,
            "invYN": "N",
            "invCondition": 1,
            "pccList": [
                "4153825"
            ],
            "markedAsDeletion": false
        },
        {
            "invId": 6670,
            "itemNo": "4070",
            "itemSeq": 0,
            "itemName": "Brick, Modified 1 x 1 with Headlight",
            "invNew": "N",
            "invComplete": "S",
            "itemType": "P",
            "invItemID": 776,
            "categoryId": 0,
            "catString": "7",
            "catNames": [
                "Brick, Modified"
            ],
            "catIds": [
                7
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/PN/11/4070.png",
            "invQty": 2,
            "invColorID": 11,
            "invYN": "N",
            "invCondition": 1,
            "pccList": [
                "407026"
            ],
            "markedAsDeletion": false
        },
        {
            "invId": 6659,
            "itemNo": "30364",
            "itemSeq": 0,
            "itemName": "Hinge Brick 1 x 2 Locking with 1 Finger Vertical End",
            "invNew": "N",
            "invComplete": "S",
            "itemType": "P",
            "invItemID": 407,
            "categoryId": 0,
            "catString": "22",
            "catNames": [
                "Hinge"
            ],
            "catIds": [
                22
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/PN/11/30364.png",
            "invQty": 2,
            "invColorID": 11,
            "invYN": "N",
            "invCondition": 1,
            "pccList": [
                "6266306",
                "4265484",
                "4250190"
            ],
            "markedAsDeletion": false
        },
        {
            "invId": 6673,
            "itemNo": "30386",
            "itemSeq": 0,
            "itemName": "Hinge Brick 1 x 2 Locking with 1 Finger Vertical End and 2 Fingers Vertical End, 9 Teeth",
            "invNew": "N",
            "invComplete": "S",
            "itemType": "P",
            "invItemID": 1972,
            "categoryId": 0,
            "catString": "22",
            "catNames": [
                "Hinge"
            ],
            "catIds": [
                22
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/PN/11/30386.png",
            "invQty": 2,
            "invColorID": 11,
            "invYN": "N",
            "invCondition": 1,
            "pccList": [
                "4167106"
            ],
            "markedAsDeletion": false
        },
        {
            "invId": 6660,
            "itemNo": "30365",
            "itemSeq": 0,
            "itemName": "Hinge Brick 1 x 2 Locking with 2 Fingers Vertical End, 9 Teeth",
            "invNew": "N",
            "invComplete": "S",
            "itemType": "P",
            "invItemID": 408,
            "categoryId": 0,
            "catString": "22",
            "catNames": [
                "Hinge"
            ],
            "catIds": [
                22
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/PN/11/30365.png",
            "invQty": 2,
            "invColorID": 11,
            "invYN": "N",
            "invCondition": 1,
            "pccList": [
                "4144502",
                "4129975"
            ],
            "markedAsDeletion": false
        },
        {
            "invId": 6647,
            "itemNo": "970c11",
            "itemSeq": 0,
            "itemName": "Hips and Black Legs",
            "invNew": "N",
            "invComplete": "S",
            "itemType": "P",
            "invItemID": 17391,
            "categoryId": 0,
            "catString": "484",
            "catNames": [
                "Minifigure, Legs"
            ],
            "catIds": [
                484
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/PN/4/970c11.png",
            "invQty": 1,
            "invColorID": 4,
            "invYN": "Y",
            "invCondition": 1,
            "pccList": [
                "4225183"
            ],
            "markedAsDeletion": false
        },
        {
            "invId": 6649,
            "itemNo": "47577pb01",
            "itemSeq": 0,
            "itemName": "Minifigure Hockey Body Armor with NHL Logo and White Number 1 Pattern",
            "invNew": "N",
            "invComplete": "S",
            "itemType": "P",
            "invItemID": 49958,
            "categoryId": 0,
            "catString": "142",
            "catNames": [
                "Minifigure, Body Wear"
            ],
            "catIds": [
                142
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/PN/11/47577pb01.png",
            "invQty": 1,
            "invColorID": 11,
            "invYN": "N",
            "invCondition": 1,
            "pccList": [
                "--"
            ],
            "markedAsDeletion": false
        },
        {
            "invId": 6648,
            "itemNo": "3626bpx133",
            "itemSeq": 0,
            "itemName": "Minifigure, Head Male Stubble, Black Messy Hair, and Angry Eyebrows Pattern - Blocked Open Stud",
            "invNew": "N",
            "invComplete": "S",
            "itemType": "P",
            "invItemID": 39010,
            "categoryId": 0,
            "catString": "238",
            "catNames": [
                "Minifigure, Head"
            ],
            "catIds": [
                238
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/PN/3/3626bpx133.png",
            "invQty": 1,
            "invColorID": 3,
            "invYN": "N",
            "invCondition": 1,
            "pccList": [
                "4187301"
            ],
            "markedAsDeletion": false
        },
        {
            "invId": 6646,
            "itemNo": "30171",
            "itemSeq": 0,
            "itemName": "Minifigure, Headgear Cap, Aviator",
            "invNew": "N",
            "invComplete": "S",
            "itemType": "P",
            "invItemID": 3240,
            "categoryId": 0,
            "catString": "16",
            "catNames": [
                "Minifigure, Headgear"
            ],
            "catIds": [
                16
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/PN/11/30171.png",
            "invQty": 1,
            "invColorID": 11,
            "invYN": "N",
            "invCondition": 1,
            "pccList": [
                "4144530",
                "4522653",
                "4587303"
            ],
            "markedAsDeletion": false
        },
        {
            "invId": 6669,
            "itemNo": "3959",
            "itemSeq": 0,
            "itemName": "Minifigure, Utensil Space Gun / Torch",
            "invNew": "N",
            "invComplete": "S",
            "itemType": "P",
            "invItemID": 762,
            "categoryId": 0,
            "catString": "18",
            "catNames": [
                "Minifigure, Utensil"
            ],
            "catIds": [
                18
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/PN/11/3959.png",
            "invQty": 1,
            "invColorID": 11,
            "invYN": "N",
            "invCondition": 1,
            "pccList": [
                "395926",
                "4254942"
            ],
            "markedAsDeletion": false
        },
        {
            "invId": 6645,
            "itemNo": "2447",
            "itemSeq": 0,
            "itemName": "Minifigure, Visor Standard",
            "invNew": "N",
            "invComplete": "S",
            "itemType": "P",
            "invItemID": 103,
            "categoryId": 0,
            "catString": "636",
            "catNames": [
                "Minifigure, Headgear Accessory"
            ],
            "catIds": [
                636
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/PN/15/2447.png",
            "invQty": 1,
            "invColorID": 15,
            "invYN": "N",
            "invCondition": 1,
            "pccList": [
                "244742",
                "4652811"
            ],
            "markedAsDeletion": false
        },
        {
            "invId": 6658,
            "itemNo": "3023",
            "itemSeq": 0,
            "itemName": "Plate 1 x 2",
            "invNew": "N",
            "invComplete": "S",
            "itemType": "P",
            "invItemID": 378,
            "categoryId": 0,
            "catString": "26",
            "catNames": [
                "Plate"
            ],
            "catIds": [
                26
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/PN/4/3023.png",
            "invQty": 3,
            "invColorID": 4,
            "invYN": "N",
            "invCondition": 1,
            "pccList": [
                "4177932"
            ],
            "markedAsDeletion": false
        },
        {
            "invId": 6665,
            "itemNo": "3623",
            "itemSeq": 0,
            "itemName": "Plate 1 x 3",
            "invNew": "N",
            "invComplete": "S",
            "itemType": "P",
            "invItemID": 634,
            "categoryId": 0,
            "catString": "26",
            "catNames": [
                "Plate"
            ],
            "catIds": [
                26
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/PN/4/3623.png",
            "invQty": 2,
            "invColorID": 4,
            "invYN": "N",
            "invCondition": 1,
            "pccList": [
                "4513281",
                "6147047",
                "4219920"
            ],
            "markedAsDeletion": false
        },
        {
            "invId": 6667,
            "itemNo": "3710",
            "itemSeq": 0,
            "itemName": "Plate 1 x 4",
            "invNew": "N",
            "invComplete": "S",
            "itemType": "P",
            "invItemID": 683,
            "categoryId": 0,
            "catString": "26",
            "catNames": [
                "Plate"
            ],
            "catIds": [
                26
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/PN/42/3710.png",
            "invQty": 2,
            "invColorID": 42,
            "invYN": "N",
            "invCondition": 1,
            "pccList": [
                "4179828"
            ],
            "markedAsDeletion": false
        },
        {
            "invId": 6657,
            "itemNo": "3020",
            "itemSeq": 0,
            "itemName": "Plate 2 x 4",
            "invNew": "N",
            "invComplete": "S",
            "itemType": "P",
            "invItemID": 369,
            "categoryId": 0,
            "catString": "26",
            "catNames": [
                "Plate"
            ],
            "catIds": [
                26
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/PN/7/3020.png",
            "invQty": 2,
            "invColorID": 7,
            "invYN": "N",
            "invCondition": 1,
            "pccList": [
                "302023"
            ],
            "markedAsDeletion": false
        },
        {
            "invId": 6671,
            "itemNo": "4073",
            "itemSeq": 0,
            "itemName": "Plate, Round 1 x 1",
            "invNew": "N",
            "invComplete": "S",
            "itemType": "P",
            "invItemID": 777,
            "categoryId": 0,
            "catString": "28",
            "catNames": [
                "Plate, Round"
            ],
            "catIds": [
                28
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/PN/17/4073.png",
            "invQty": 1,
            "invColorID": 17,
            "invYN": "N",
            "invCondition": 1,
            "pccList": [
                "3005741",
                "6208450"
            ],
            "markedAsDeletion": false
        },
        {
            "invId": 6663,
            "itemNo": "3040",
            "itemSeq": 0,
            "itemName": "Slope 45 2 x 1",
            "invNew": "N",
            "invComplete": "S",
            "itemType": "P",
            "invItemID": 428,
            "categoryId": 0,
            "catString": "31",
            "catNames": [
                "Slope"
            ],
            "catIds": [
                31
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/PN/7/3040.png",
            "invQty": 2,
            "invColorID": 7,
            "invYN": "N",
            "invCondition": 1,
            "pccList": [
                "4121936",
                "304023"
            ],
            "markedAsDeletion": false
        },
        {
            "invId": 6664,
            "itemNo": "3040",
            "itemSeq": 0,
            "itemName": "Slope 45 2 x 1",
            "invNew": "N",
            "invComplete": "S",
            "itemType": "P",
            "invItemID": 428,
            "categoryId": 0,
            "catString": "31",
            "catNames": [
                "Slope"
            ],
            "catIds": [
                31
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/PN/42/3040.png",
            "invQty": 4,
            "invColorID": 42,
            "invYN": "N",
            "invCondition": 1,
            "pccList": [
                "4626883",
                "4128582"
            ],
            "markedAsDeletion": false
        },
        {
            "invId": 6661,
            "itemNo": "3039",
            "itemSeq": 0,
            "itemName": "Slope 45 2 x 2",
            "invNew": "N",
            "invComplete": "S",
            "itemType": "P",
            "invItemID": 417,
            "categoryId": 0,
            "catString": "31",
            "catNames": [
                "Slope"
            ],
            "catIds": [
                31
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/PN/4/3039.png",
            "invQty": 2,
            "invColorID": 4,
            "invYN": "N",
            "invCondition": 1,
            "pccList": [
                "4118828"
            ],
            "markedAsDeletion": false
        },
        {
            "invId": 6662,
            "itemNo": "3039",
            "itemSeq": 0,
            "itemName": "Slope 45 2 x 2",
            "invNew": "N",
            "invComplete": "S",
            "itemType": "P",
            "invItemID": 417,
            "categoryId": 0,
            "catString": "31",
            "catNames": [
                "Slope"
            ],
            "catIds": [
                31
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/PN/42/3039.png",
            "invQty": 1,
            "invColorID": 42,
            "invYN": "N",
            "invCondition": 1,
            "pccList": [
                "4143135",
                "6092038"
            ],
            "markedAsDeletion": false
        },
        {
            "invId": 6674,
            "itemNo": "40996",
            "itemSeq": 0,
            "itemName": "Slope, Curved 4 x 1 with Two Studs",
            "invNew": "N",
            "invComplete": "S",
            "itemType": "P",
            "invItemID": 8780,
            "categoryId": 0,
            "catString": "438",
            "catNames": [
                "Slope, Curved"
            ],
            "catIds": [
                438
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/PN/16/40996.png",
            "invQty": 1,
            "invColorID": 16,
            "invYN": "N",
            "invCondition": 1,
            "pccList": [
                "4154081"
            ],
            "markedAsDeletion": false
        },
        {
            "invId": 6675,
            "itemNo": "42022",
            "itemSeq": 0,
            "itemName": "Slope, Curved 6 x 1",
            "invNew": "N",
            "invComplete": "S",
            "itemType": "P",
            "invItemID": 11057,
            "categoryId": 0,
            "catString": "438",
            "catNames": [
                "Slope, Curved"
            ],
            "catIds": [
                438
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/PN/7/42022.png",
            "invQty": 2,
            "invColorID": 7,
            "invYN": "N",
            "invCondition": 1,
            "pccList": [
                "4160391"
            ],
            "markedAsDeletion": false
        }
    ];
	return itemList;
}

